module.exports = __webpack_public_path__ + "img/pic_351251_1.4aa4accc.jpg";